import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import {
  HiArrowDownTray,
  HiGlobeAlt,
  HiHome,
  HiPhoto,
  HiShoppingCart,
  HiUser,
} from "react-icons/hi2";
import { useSelector } from "react-redux";
import { useIndexPageData } from "../contextapi/Indexpagedata";
import DashboardSideNavContent from "../components/dashboard/DashboardSideNavContent";

const drawerWidth = 280;
const desktopDrawerWidth = 250;

const listItemData = [
  {
    label: "Dashboard",
    link: "/user/dashboard",
    icon: HiHome,
    end: true,
  },
  {
    label: "My Mockups",
    link: "/user/my-mockups",
    icon: HiPhoto,
  },
  {
    label: "Purchases",
    link: "/user/payments",
    icon: HiShoppingCart,
  },
  {
    label: "User Information",
    link: "/user/info",
    icon: HiUser,
  },
  {
    label: "My Downloads",
    link: "/user/my-downloads",
    icon: HiArrowDownTray,
  },
];

function SideNav(props) {
  const { profiledata } = useIndexPageData();
  const { userType } = useSelector((state) => state.auth);
  const { window } = props;

  const renderDrawer = (isMobile) => (
    <DashboardSideNavContent
      title="User Hub"
      subtitle="Account"
      switchLink={
        userType === "S"
          ? {
              to: "/seller/dashboard",
              label: "Go to Seller Dashboard",
            }
          : userType === "F"
            ? {
                to: "/affiliate/dashboard",
                label: "Go to Affiliate Dashboard",
              }
          : null
      }
      navItems={listItemData}
      profiledata={profiledata}
      isMobile={isMobile}
      onClose={props.handleDrawerToggle}
    />
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const drawerPaperStyles = {
    boxSizing: "border-box",
    border: "none",
    bgcolor: "#151821",
    color: "#fff",
    overflow: "hidden",
    zIndex: { md: 900, xs: 1201 },
  };

  return (
    <Box
      component="nav"
      sx={{
        width: { md: desktopDrawerWidth },
        flexShrink: { md: 0 },
      }}
      aria-label="User dashboard navigation"
    >
      <Drawer
        container={container}
        variant="temporary"
        open={props.mobileOpen}
        onClose={props.handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            ...drawerPaperStyles,
            width: drawerWidth,
            maxWidth: "88vw",
          },
        }}
      >
        {renderDrawer(true)}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            ...drawerPaperStyles,
            width: desktopDrawerWidth,
          },
        }}
        open
      >
        {renderDrawer(false)}
      </Drawer>
    </Box>
  );
}

SideNav.propTypes = {
  window: PropTypes.func,
  mobileOpen: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
};

export default SideNav;
